import { useState } from "react";
import { toast } from "sonner";
import { Download, FileText, FileCode2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function ExportMenu({ docIds, disabled }) {
  const [busy, setBusy] = useState(false);
  const download = async (format) => {
    setBusy(true);
    try {
      const resp = await api.get("/chat/export", { params: { document_ids: [...docIds].sort().join(","), format }, responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(resp.headers["content-disposition"] || "")?.[1] || `documind-chat.${format}`;
      const url = URL.createObjectURL(resp.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success(`Exported ${name}`);
    } catch (err) {
      const detail = err.response?.data instanceof Blob ? JSON.parse(await err.response.data.text().catch(() => "{}"))?.detail : err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Export failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid="chat-export-btn" disabled={disabled || busy} className="rounded-sm">
          {busy ? <Loader2 className="w-4 h-4 sm:mr-2 animate-spin" /> : <Download className="w-4 h-4 sm:mr-2" />}<span className="hidden sm:inline">Export</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm">
        <DropdownMenuLabel className="font-mono-label text-muted-foreground">Download this chat</DropdownMenuLabel>
        <DropdownMenuItem data-testid="chat-export-pdf" onClick={() => download("pdf")}><FileText className="w-4 h-4 mr-2" /> PDF</DropdownMenuItem>
        <DropdownMenuItem data-testid="chat-export-md" onClick={() => download("md")}><FileCode2 className="w-4 h-4 mr-2" /> Markdown (.md)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
